import client from "./client";

export default {
    async getPropertyStatuses(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/property-statuses', filters)));
    },

    async createPropertyStatuses(data) {
        return client.parseResponse(await client.post('/property-statuses', data))
    },

    async getPropertyStatus(id) {
        return client.parseResponse(await client.get('/property-statuses/' + id));
    },

    async editPropertyStatus(data) {
        return client.parseResponse(await client.put('/property-statuses/' + data.id, data))
    },

    async deletePropertyStatus(data) {
        return client.parseResponse(await client.delete('/property-statuses/' + data.id, data))
    }
}
